import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaTelegram,
  FaDiscord,
  FaWhatsapp,
  FaLinkedin,
  FaTiktok
} from 'react-icons/fa';
import { SiKick } from 'react-icons/si';

const SocialMedia = () => {
  const [socialMedia, setSocialMedia] = useState([]);

  useEffect(() => {
    fetchSocialMedia();
  }, []);

  const fetchSocialMedia = async () => {
    try {
      const response = await axios.get('/api/social-media');
      setSocialMedia(response.data);
    } catch (error) {
      console.error('Error fetching social media:', error);
    }
  };

  const getIcon = (platform) => {
    const icons = {
      facebook: FaFacebook,
      twitter: FaTwitter,
      instagram: FaInstagram,
      youtube: FaYoutube,
      telegram: FaTelegram,
      discord: FaDiscord,
      whatsapp: FaWhatsapp,
      linkedin: FaLinkedin,
      tiktok: FaTiktok,
      kick: SiKick,
    };

    const Icon = icons[platform.toLowerCase()] || FaFacebook;
    return <Icon className="w-8 h-8" />;
  };

  if (socialMedia.length === 0) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 rounded-xl p-8 shadow-premium border-2 border-gold/30 premium-card">
      <h2 className="text-3xl font-bold text-center text-gold mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]">
        Sosyal Medya
      </h2>
      <div className="flex flex-wrap justify-center gap-6">
        {socialMedia.map((social) => (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-2 transition-all duration-300 hover:scale-110"
          >
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-gold/20 to-yellow-500/20 flex items-center justify-center text-gold group-hover:shadow-[0_0_25px_rgba(212,175,55,0.6)] transition-all duration-300 border-2 border-gold/50 group-hover:border-gold">
              {getIcon(social.platform)}
            </div>
            <span className="text-white text-sm font-medium group-hover:text-gold transition-colors">{social.platform}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialMedia;
